import {Drawer} from 'presentation/components/Drawer';
import React, {Fragment} from 'react';
import {OdontoBookingTaggingEnum} from 'main/analytics/gaTagsEnum';
import {OdontoFilterProps} from './types';

export function OdontoFilter({
	servingPeopleWithDisabilities,
	handleClearDisability,
	handleConfirmDisability,
}: OdontoFilterProps) {
	return (
		<Fragment>
			<Drawer.ContentListByCategorySwitch
				categoryList={[servingPeopleWithDisabilities]}
				dataTagId={OdontoBookingTaggingEnum.CLICK_FILTRAR_UNIDADES_PCD_ODONTO}
			/>
			<Drawer.Footer
				firstButtonDataTagId={OdontoBookingTaggingEnum.CLICK_LIMPAR_FILTRO_UNIDADES_ODONTO}
				firstButtonOnClick={handleClearDisability}
				secondButtonDataTagId={
					OdontoBookingTaggingEnum.CLICK_APLICAR_FILTRO_UNIDADES_ODONTO
				}
				secondButtonOnClick={handleConfirmDisability}
			/>
		</Fragment>
	);
}
